import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Search.css';

function Search({ categories }) {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search-results?query=${encodeURIComponent(searchQuery.trim())}`);
    } else {
      alert('Arama yapılacak kelime girmelisiniz.');
    }
  };

  const handleCategoryClick = (categoryId) => {
    navigate(`/category/${categoryId}`);
  };

  return (
    <div className="mobile-search-page">
      <form onSubmit={handleSearch} className="mobile-search-form">
        <input
          type="search"
          placeholder="Kitap veya yazar ara..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          autoFocus
          className="mobile-search-input"
        />
        <button type="submit" className="mobile-search-button">Ara</button>
      </form>

      <div className="mobile-categories">
        <h2>Kategoriler</h2>
        <div className="mobile-category-grid">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => handleCategoryClick(category.id)}
              className="mobile-category-button"
            >
              {category.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Search;
